<template>
  <div class="col-lg-12" >
    <v-container>
      <v-layout row wrap>
        <!--<v-flex lg3 md3 sm12 xs12>-->
        <!--<v-btn :depressed="true" color="primary" block @click="last7()">Previous Week</v-btn>-->
        <!--</v-flex>-->
        <v-flex lg12 md12 sm12 xs12>
          <v-layout row wrap>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="calendar.start_date"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Date"
                    v-model="calendar.start_date"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="calendar.start_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                    <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(calendar.start_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="calendar.end_date"
                >
                  <v-text-field
                    slot="activator"
                    label="End Date"
                    v-model="calendar.end_date"
                    readonly
                  ></v-text-field>
                  <v-date-picker :min="calendar.start_date" v-model="calendar.end_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                    <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(calendar.end_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <br>
              <v-btn :depressed="true" color="primary" @click="getData()" block :loading="this.$store.state.LoadingStore.loading">Get Selected Dates</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <!--<v-flex lg3 md3 sm12 xs12>-->
        <!--<v-btn :depressed="true" color="info" block @click="next7()">Next Week</v-btn>-->
        <!--</v-flex>-->
      </v-layout>
    </v-container>
    <v-container fluid style="overflow: auto">
      <table class="table table-responsive" cellspacing="0">
        <tbody>
        <tr>
          <td>
          </td>
          <td  v-for="(n, key) in getWeek" :key="key">
            <p style="font-size: small" class="">Capacity Taken</p>
          </td>
        </tr>
        <tr>
          <td>
          </td>
          <td  v-for="(date, key) in getWeek" :class="{local_red: getDay(date) }" :key="key">
            <h4 class="title text-lg-center text-md-center">{{formatDate(date)}}</h4>
          </td>
        </tr>
        <tr>
          <td>
            Conservation Residencies and Vehicles
          </td>
          <td class="local_green" v-for="(date, key) in getWeek" :class="{danger: getDay(date)}" :key="key">
            {{date}}
          </td>
        </tr>
        <tr v-for="(conservation, key) in getConservationFeeCalendar" :key="'conservation' + key">
          <td class="local_yellow">{{conservation.payment_person}}</td>
          <td :class="{local_red: getDay(slot.date)}" v-for="(slot, key) in conservation.conservancy_fee_details" :key="key">
            <v-btn  v-if="slot.conservancy_fee_count === 0" color="default" :depressed="true" @click="getConservationDetails(conservation.payment_public_id, slot.date)" small >{{slot.conservancy_fee_count}}</v-btn>
            <v-btn v-if="slot.conservancy_fee_count > 0" color="primary" :depressed="true" @click="getConservationDetails(conservation.payment_public_id, slot.date)" small >{{slot.conservancy_fee_count}}</v-btn>
          </td>
        </tr>
        <tr v-for="(vehicle, key) in getVehicleFeeCalendar" :key="'vehicle' + key">
          <td class="warning-d">{{vehicle.vehicle_charge_category}}</td>
          <td :class="{local_red: getDay(slot.date)}" v-for="(slot, key) in vehicle.vehicle_details" :key="key">
            <v-btn v-if="slot.vehicle_count === 0" color="default" :depressed="true" round @click="getVehicleDetails(vehicle.vehicle_charge_public_id, slot.date)" small >{{slot.vehicle_count}}</v-btn>
            <v-btn v-if="slot.vehicle_count > 0" color="primary" :depressed="true" @click="getVehicleDetails(vehicle.vehicle_charge_public_id, slot.date)" small >{{slot.vehicle_count}}</v-btn>
          </td>
        </tr>
        <!--<tr v-for="(inventory, key) in getInventoryCalendar" :key="'inventory' + key">-->
        <!--<td class="local_green">{{inventory.inventory_name}}</td>-->
        <!--<td :class="{local_red: getDay(slot.date)}" v-for="(slot, key) in inventory.inventory_details" :key="key">-->
        <!--<v-btn v-if="slot.available_slots === 0" color="error" :depressed="true" @click="getInventoryDetails(inventory.inventory_id, slot.date)" small >{{slot.available_slots}}</v-btn>-->
        <!--<v-btn v-if="slot.available_slots > 0" color="default" :depressed="true" @click="getInventoryDetails(inventory.inventory_id, slot.date)" small >{{slot.available_slots}}</v-btn>-->
        <!--</td>-->
        <!--</tr>-->
        </tbody>
      </table>
    </v-container>
    <div class="text-xs-center">
      <v-bottom-sheet v-model="sheet">
        <v-list>
          <v-subheader>Bookings</v-subheader>
          <bookings></bookings>
        </v-list>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerConservationDashboard',
  data () {
    return {
      lmenu: JSON.parse(localStorage.getItem('unem')),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      date_settings: {
        night: 'Day',
        nights: 'Days',
        'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
        'check-in': 'Start-Date',
        'check-out': 'End-Date',
        'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      today: this.$moment.now(),
      calendar: {
        partner_id: JSON.parse(localStorage.getItem('unem')).instiution_id,
        start_date: this.$moment(this.today).format('YYYY-MM-DD'),
        end_date: this.$moment(this.today).add(10, 'days').format('YYYY-MM-DD')
      },
      sheet: false
    }
  },
  created () {
    this.$store.dispatch('get_partner_conservation_vehicle_calendar', this.calendar)
  },
  methods: {
    getConservationDetails (conservationPublicId, date) {
      this.sheet = true
      var data = {
        guest_id: conservationPublicId,
        date: this.$moment(date).format('YYYY-MM-DD'),
        partner_id: this.lmenu.instiution_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('get_conservation_partner_bookings', data)
    },
    getVehicleDetails (vehiclePublicId, date) {
      this.sheet = true
      var data = {
        vehicle_id: vehiclePublicId,
        date: this.$moment(date).format('YYYY-MM-DD'),
        partner_id: this.lmenu.instiution_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('get_vehicle_partner_bookings', data)
    },
    formatDate (date) {
      return this.$moment(date).format('ddd')
    },
    getDay: function (day) {
      var date = this.$moment(day).weekday()
      if (date === 6 | date === 0) {
        return true
      } else {
        return false
      }
    },
    getData: function () {
      this.$store.dispatch('loading_true')
      this.$store.dispatch('get_calendar', this.calendar)
    },
    next7: function () {
      var start = this.$moment(this.today).add(7, 'days').format('YYYY-MM-DD')
      this.calendar.start_date = start
      this.calendar.end_date = this.$moment(start).add(7, 'days').format('YYYY-MM-DD')
      this.today = start
      this.$store.dispatch('get_calendar', this.calendar)
    },
    last7: function () {
      var start = this.$moment(this.today).subtract(7, 'days').format('YYYY-MM-DD')
      this.calendar.start_date = start
      this.calendar.end_date = this.$moment(start).subtract(7, 'days').format('YYYY-MM-DD')
      this.today = start
      this.$store.dispatch('get_calendar', this.calendar)
    }
  },
  computed: {
    getWeek: function () {
      var start = this.calendar.start_date
      var a = this.$moment(this.$moment(this.calendar.start_date).format('YYYY, MM, DD'))
      var b = this.$moment(this.$moment(this.calendar.end_date).format('YYYY, MM, DD'))
      var max = b.diff(a, 'days')
      var days = []
      for (var i = 0; i <= max; i++) {
        var day = this.$moment(start).add(i, 'days').format('DD MMM, YYYY')
        days.push(day)
      }
      return days
    }
  }
}
</script>

<style scoped>
  .warning-d {
    background-color: #520036;
    color: white;
  }
  .local_red {
    background-color: #FFCDD2;
  }
  .local_yellow {
    background-color: #fdb813;
  }
  .local_green {
    background-color: #73a533;
  }
</style>
